import { HttpErrorResponse } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";

import { Observable, throwError } from "rxjs";

import { AlertService } from "@sharedServices/alert.service";

/**
 * Provides a centralized way to handle exceptions.
 */
@Injectable({ providedIn: 'root' })
export class ExceptionProvider {
  private _alertService = inject(AlertService);

  /**
   * Handles generic HTTP errors.
   *
   * @param error - The HttpErrorResponse to handle.
   * @returns An observable that throws an error.
   */
  handleGenricError(error: HttpErrorResponse): Observable<never> {
    const message = error.error?.message || error.message;
    this._alertService.error(message);
    return throwError(() => error);
  }
}
